import React, { Component } from "react";
import "./member.scss";
export default class menberExplanation extends React.Component {
  state = {
    price: [
      {
        time: "1个月",
        beans: "160金豆",
        pricetime: "16元/月",
      },
      {
        time: "6个月",
        beans: "888金豆",
        pricetime: "14.8元/月",
      },
      {
        time: "1年",
        beans: "1588金豆",
        pricetime: "13.2元/月",
      },
    ],
  };
  render() {
    return (
      <div className="menberExplanationHome">
        <header><img src="http://image.ybk008.com/banner1607052181988" alt=""/></header>
        <div className="ExplanationHome">
          <h3>尊敬的邮宝用户：</h3>
          <div className="content">
          自2020年6月邮宝升级以来，新的会员体系(2.0)得到了广大用户的积极支持。2020年11月，我们又推出了邮宝拍卖业务，大量用户得以进驻。拍卖和现货交易互相补充，为邮宝用户对不同商品进行差异化交易提供了坚实的保障。然而，随着业务的持续增长，邮宝拍卖也开始出现少数用户频繁地毁约等严重扰乱平台秩序的乱象。为了进一步规范用户交易行为，给广大真正的集藏爱好者提供良好的经营环境，我们继续升级邮宝会员体系至3.0。 <br/>升级后的邮宝用户分为游客、注册用户、认证用户、会员(免费获取会员资格的会员)，VIP会员(付费会员)5个级别。
          </div>
          <div className="jaige">用户权限表</div>
          <img src="http://image.ybk008.com/biaoge_011607052235547" alt="" className="tabel_img"/>
          <img src="http://image.ybk008.com/biaoge1608719889019" alt="" className="tabel_img"/>
          <div className="content contTime">
          邮宝会员体系3.0自本公告公布之日起实施。<br/> 北京风暴迅达科技有限公司
          </div>
          <div className="usertable"></div>
          <div className="zhaiwei"></div>
        </div>
      </div>
    );
  }
}
